<div
  class="flex flex-col w-full min-h-[2.5rem] justify-center -space-y-1"
  [class.items-start]="align === 'left'"
  [class.items-center]="align === 'center'"
  [class.text-center]="align === 'center'"
>
  <div>
    <span>{{ item.inventoryCode }}</span>
    @if (item.itemDisputationType; as type) {
      <span class="pl-0.5 font-semibold">{{ type.shortcut }}</span>
    }
  </div>
  @if (item.parentId) {
    <div class="text-xs">
      {{ item.parent.inventoryCode }}_{{ item.parentOrder }}
    </div>
  }
</div>
